export const defaultObject = [{
    type: 'Text',
    value: `Enter Text`,
    width: 50,
    height: 25,
    x: 0,
    y: 0,
    rotate: 0,
    radius: [0,0,0,0],
    differentRadius: false,
    zIndex: 1,
    bold: false,
    underline: false,
    italic: false,
    size: 12,
    textAlign: 'left',
    font: 'Ariel',
    textColor: [0,0,0,1],
    fillColor: [0,0,0,0],
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderColor: [0,0,0,1],
},
{
    type: 'Square',
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    rotate: 0,
    radius: [0,0,0,0],
    differentRadius: false,
    zIndex: 1,
    fillColor: [190,190,190,1],
    borderStyle: 'none',
    borderWidth: 0,
    borderColor: [0,0,0,1],
},
{
    type: 'Ellipse',
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    rotate: 0,
    zIndex: 1,
    fillColor: [190,190,190,1],
    borderStyle: 'none',
    borderWidth: 0,
    borderColor: [0,0,0,1],
},
{
    height: 0,
    type: 'Line',
    width: 50,
    x: 0,
    y: 0,
    rotate: 0,
    zIndex: 1,
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: [0,0,0,1],
},
{
    type: 'Image',
    src: '',
    fileName: '',
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    rotate: 0,
    radius: [0,0,0,0],
    differentRadius: false,
    zIndex: 1,
    borderStyle: 'none',
    borderWidth: 0,
    borderColor: [0,0,0,1],
},
{
    type: 'Icon',
    code: '',
    class: 'material-icons',
    width: 15,
    x: 0,
    y: 0,
    rotate: 0,
    radius: [0,0,0,0],
    differentRadius: false,
    zIndex: 1,
    borderStyle: 'none',
    borderWidth: 0,
    borderColor: [0,0,0,1],
    fillColor: [0,0,0,1],
},
]

// {
//     type: 'Square',
//     width: 25,
//     height: 25,
//     x: 0,
//     y: 0,
//     rotate: 0,
//     radius: [0,0,0,0],
//     differentRadius: false,
//     zIndex: 1002,
//     fillColor: [150,150,150,1],
//     borderStyle: 'none',
//     borderWidth: 0,
//     borderColor: [0,0,0,1],
// },
// {
//     type: 'Text',
//     value: `Hi, it's Igor`,
//     width: 20,
//     height: 20,
//     x: 0,
//     y: 30,
//     rotate: 0,
//     radius: [0,0,0,0],
//     differentRadius: false,
//     zIndex: 1001,
//     bold: false,
//     underline: false,
//     italic: false,
//     size: 14,
//     textAlign: 'left',
//     font: 'Lobster',
//     textColor: [0,0,0,1],
//     fillColor: [255,255,255,1],
//     borderStyle: 'none',
//     borderWidth: 0,
//     borderColor: [0,0,0,1],
// },
// {
//     type: 'Text',
//     value: `Hi, it's Dorothy`,
//     width: 20,
//     height: 20,
//     x: 10,
//     y: 70,
//     rotate: 0,
//     radius: [5,5,5,5],
//     differentRadius: false,
//     zIndex: 1003,
//     bold: true,
//     underline: true,
//     italic: true,
//     size: 12,
//     textAlign: 'left',
//     font: 'Arial',
//     textColor: [0,0,0,1],
//     fillColor: [255,255,255,1],
//     borderStyle: 'none',
//     borderWidth: 0,
//     borderColor: [0,0,0,1],
// },
// {
//     type: 'Line',
//     height: 0,
//     width: 50,
//     x: 1,
//     y: 60,
//     rotate: 0,
//     zIndex: 1004,
//     borderStyle: 'solid',
//     borderWidth: 1,
//     borderColor: [0,0,0,1],
// },
// {
//     type: 'Ellipse',
//     width: 25,
//     height: 25,
//     x: 30,
//     y: 0,
//     rotate: 0,
//     zIndex: 1005,
//     fillColor: [230,255,255,1],
//     borderStyle: 'none',
//     borderWidth: 0,
//     borderColor: [0,0,0,1],
// },
// {
//     type: 'Image',
//     src: '../../logo192.png',
//     width: 25,
//     height: 25,
//     x: 40,
//     y: 80,
//     rotate: 0,
//     radius: [0,0,0,0],
//     differentRadius: false,
//     zIndex: 1006,
//     borderStyle: 'none',
//     borderWidth: 0,
//     borderColor: [0,0,0,1],
// },
// {
//     type: 'Icon',
//     code: 'battery_0_bar',
//     class: 'material-icons',
//     width: 25,
//     x: 0,
//     y: 0,
//     rotate: 0,
//     radius: [0,0,0,0],
//     differentRadius: false,
//     zIndex: 1007,
//     borderStyle: 'none',
//     borderWidth: 0,
//     borderColor: [0,0,0,1],
//     fillColor: [0,0,0,1],
// },

// {
//     name: 'First Draft',
//     size: 'Custom',
//     unit: 'mm',
//     width: 100,
//     height: 200,
//     margin: [10,10,10,10],
//     differentMargin: false,
//     fillColor: [255,255,255,1]
// }